import { createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-start gap-4" }
const _hoisted_2 = { class: "min-w-0 flex-1" }
const _hoisted_3 = { class: "mb-1.5 flex flex-wrap items-center gap-2" }
const _hoisted_4 = { class: "text-[10px] font-bold uppercase tracking-wider text-[#737373]" }
const _hoisted_5 = { class: "text-sm font-semibold text-[#242B59]" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2.5 flex items-start gap-1.5 text-xs leading-relaxed text-[#626468]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-2xl border border-[#E5E7EB] bg-[#F8FAFC] px-5 py-4 shadow-[0px_1px_3px_rgba(0,0,0,0.05),0px_1px_2px_rgba(0,0,0,0.03)] transition-all", 
            $setup.isWarning($setup.props.errorType)
                ? 'border-l-4 border-l-[#F59E0B]'
                : 'border-l-4 border-l-[#EF4444]'
        ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" Circular Icon Container "),
      _createElementVNode("div", {
        class: _normalizeClass(["flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border border-[#E5E7EB] bg-white shadow-sm", $setup.isWarning($setup.props.errorType) ? 'text-[#D97706]' : 'text-[#DC2626]'])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent($setup.iconByType[$setup.props.errorType]), { class: "h-5 w-5" }))
      ], 2 /* CLASS */),
      _createCommentVNode(" Content Column "),
      _createElementVNode("div", _hoisted_2, [
        _createCommentVNode(" Header Title & Pill "),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.labelByType[$setup.props.errorType]), 1 /* TEXT */),
          _createElementVNode("span", {
            class: _normalizeClass(["rounded px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider shadow-sm", 
                            $setup.isWarning($setup.props.errorType)
                                ? 'bg-[#FEF3C7] text-[#D97706]'
                                : 'bg-[#FEE2E2] text-[#DC2626]'
                        ])
          }, _toDisplayString($setup.isWarning($setup.props.errorType) ? 'atenção' : 'erro'), 3 /* TEXT, CLASS */)
        ]),
        _createCommentVNode(" Bold Main Message "),
        _createElementVNode("p", _hoisted_5, _toDisplayString($props.message), 1 /* TEXT */),
        _createCommentVNode(" Suggestion/Reformulation Subtext "),
        ($props.suggestion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("svg", {
                class: "mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-amber-500",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                })
              ], -1 /* CACHED */)),
              _createElementVNode("span", null, _toDisplayString($props.suggestion), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Dismiss Button "),
      ($props.dismissible)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "rounded-lg p-1 text-[#A3A3A3] transition-colors hover:bg-black/5",
            onClick: $setup.dismiss
          }, [
            _createVNode($setup["XIcon"], { class: "h-5 w-5" })
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}